import { render } from "./ProfileView.vue?vue&type=template&id=1de222d1"
import script from "./ProfileView.vue?vue&type=script&lang=js"
export * from "./ProfileView.vue?vue&type=script&lang=js"

import "./ProfileView.vue?vue&type=style&index=0&id=1de222d1&lang=css"

import exportComponent from "/Users/vaninamikova/Documents/Learning/Old Projects/tab-tracker/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__